import ComponentNotFound from './ComponentNotFound';

const getComponent = (componentList, type) => {
  if (typeof componentList[type] === 'undefined') {
    return ComponentNotFound;
  }
  return componentList[type];
};
export default getComponent;
